/*
 * Klaviyo cart permalinks.
 * render at: layout/theme.liquid
 * docs: https://shopify.dev/docs/apps/checkout/cart-permalinks/create, https://community.shopify.com/c/shopify-design/cart-use-permalinks-to-pre-load-the-cart/td-p/613702, https://gist.github.com/ryankelly-klaviyo/fe7b9f581d768e7875d1f017c9102ac5
 */

/*
  permalink example: https://fashionablehats.com/cart/33871748694156:1
  tested with product: https://fashionablehats.com/products/rosebud-dobbs-straw-fedora-hat-dsrbud
*/
document.addEventListener("DOMContentLoaded", function () {
  const SHOP_URL = 'https://fashionablehats.com'
  
  const form = document.querySelector("form[action='/cart/add'].f8pr-buy-button");
  console.log(form)

  if(!form){
    console.log("Can't found form for klaviyo permalink")
    return
  }
    

  let tmp = form.submit;

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    e.stopPropagation();

    const dataForm = formToJSON(e.target.elements);
    //console.log("c1", dataForm);

    const permaLink = `${SHOP_URL}/cart/${dataForm.id}:${dataForm?.quantity ?? 1}`;
    //console.log("permaLink", permaLink);

    klaviyo.push(['track', 'Added to Cart', permaLink]);

    // Trigger form
    tmp.apply(form);
  })

});

const formToJSON = (elements) =>
  [].reduce.call(
    elements,
    (data, element) => {
      data[element.name] = element.value;
      return data;
    },
    {}
  );
